/**
 * @generated SignedSource<<e0ad259c05d78e4e8ec1dcdb7207f793>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type StorecastDeviceInputMode = "SIGNAGE" | "TOUCH";
import { FragmentRefs } from "relay-runtime";
export type StorecastScreenAdminModeSelector_StorecastScreen$data = {
  readonly id: string;
  readonly inputMode: StorecastDeviceInputMode | null;
  readonly recommendedInputMode: StorecastDeviceInputMode | null;
  readonly " $fragmentType": "StorecastScreenAdminModeSelector_StorecastScreen";
};
export type StorecastScreenAdminModeSelector_StorecastScreen$key = {
  readonly " $data"?: StorecastScreenAdminModeSelector_StorecastScreen$data;
  readonly " $fragmentSpreads": FragmentRefs<"StorecastScreenAdminModeSelector_StorecastScreen">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "StorecastScreenAdminModeSelector_StorecastScreen",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "inputMode",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "recommendedInputMode",
      "storageKey": null
    }
  ],
  "type": "StorecastScreen",
  "abstractKey": null
};

(node as any).hash = "52469b73f7bcc293dbcc397c40348589";

export default node;
